import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  data: null,
  error: null,
};

export default function BroadcastsSelected(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Broadcasts.Selected.SET_DATA:
      return { ...state, data: action.data };
    case Action.Broadcasts.Selected.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Broadcasts.Selected.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Broadcasts.Selected.CLEAR:
      return { ...state, list: null };
    default:
      return state;
  }
}
